import React from 'react';
import '../css/Payment.css';
import { url } from '../env.json';

export default class PaymentPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentForm: null
        }
    }

    componentDidMount() {
        // console.log(this.props);
        let script = document.createElement('script');
        script.src = "https://js.squareup.com/v2/paymentform";
        script.type = "text/javascript";
        script.async = false;
        script.onload = () => {this.buildPaymentForm()}
        document.getElementsByTagName("head")[0].appendChild(script);
    }

    buildPaymentForm() {
        // console.log(window.SqPaymentForm);
        const that = this;
        const SqPaymentForm = new window.SqPaymentForm({
            applicationId: "sq0idp-qSVtBdVepYefri_mIvud9g",
            inputClass: 'sq-input',
            autoBuild: false,
            inputStyles: [{
                fontSize: '14px',
                lineHeight: '20px',
                padding: '16px',
                placeholderColor: '#a0a0a0',
                backgroundColor: 'transparent'
            }],
            cardNumber: {
                elementId: 'sq-card-number',
                placeholder: 'Card Number'
            },
            cvv: {
                elementId: 'sq-cvv',
                placeholder: 'CVV'
            },
            expirationDate: {
                elementId: 'sq-expiration-date',
                placeholder: 'MM/YY'
            },
            postalCode: {
                elementId: 'sq-postal-code',
                placeholder: 'Postal Code'
            },
            callbacks: {
                cardNonceResponseReceived: function (errors, nonce, cardData) {
                    if (errors) {
                        console.log('Encountered errors:');
                        errors.forEach(function (err) {
                            console.log(' ' + err.message);
                            let errMsg = err.message;
                            that.props.changeRegisterMessage(errMsg);
                        });
                        return;
                    }

                    fetch(url + '/process-payment', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            nonce: nonce
                        })
                    })
                    .catch(err => {
                        alert('Network error: ' + err);
                    })
                    .then(response => {
                        if (!response.ok) {
                            return response.text().then(errorInfo => Promise.reject(errorInfo));
                        }
                        return response.text();
                    })
                    .then(data => {
                        // console.log(JSON.stringify(data));
                        // alert('Payment completed successfully!');
                        that.props.paymentSuccess();
                    })
                    .catch(err => {
                        // console.log(JSON.parse(err));
                        let msg = JSON.parse(err);
                        let msg1 = JSON.parse(msg.result);
                        let errMsg = msg1.errors[0].code
                        // console.log(errMsg);
                        // alert('Payment failed.\nPlease try again.');
                        that.props.paymentFail(errMsg);
                    })
                }
            }
        });

        SqPaymentForm.build();

        this.setState({
            paymentForm: SqPaymentForm
        })
    }

    onGetCardNonce(event) {
        event.preventDefault();
        this.state.paymentForm.requestCardNonce();
    }
    
    render() {
        // console.log(this.props.registerMessageColor);
        return(
            <div className="app-page" id="form-container">
                {/* <img alt="cuppy-register-logo" id="register-logo" src="https://s3-us-west-2.amazonaws.com/cuppy-assets/logo.png" /> */}
                <div id="register-info-container">
                    <strong>Your CUPPY membership fee is charged once annually. Membership perks include:</strong><br/>
                    <ul className="list-of-items">
                        <li>a max. of 2 cups to be checked out at any given time</li>
                        <li>unlimited transactions using cuppys as long as previously checked out cups are returned</li>
                        <li>more benefits to come!</li>
                    </ul>
                </div>
                <div id="sq-card-number"></div>
                <div className="third" id="sq-expiration-date"></div>
                <div className="third" id="sq-cvv"></div>
                <div className="third" id="sq-postal-code"></div>
                <button id="sq-creditcard" className="button-credit-card" onClick={(event) => {this.onGetCardNonce(event)}}>Pay $5.00</button>
                <br/>
                <div id="register-message-container" >
                    <span id="register-msg" style={this.props.registerMessageColor}>{this.props.registerMessage}</span>
                </div>
                <br/>
                <button id="cancel-payment-btn" onClick={() => {this.props.cancelPayment()}}>&lt; Cancel</button>
            </div>
        )
    }
}